import { render, staticRenderFns } from "./OpeningstatisticsJg.vue?vue&type=template&id=3a3e0b75"
import script from "./OpeningstatisticsJg.vue?vue&type=script&lang=js"
export * from "./OpeningstatisticsJg.vue?vue&type=script&lang=js"
import style0 from "./OpeningstatisticsJg.vue?vue&type=style&index=0&id=3a3e0b75&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports